import * as React from 'react';
import * as blocks from './style.module.scss';

export const data = [
  {
    icon: 'https://fs.advance.ru/landing-pages/indi/kak_uchitya_doma/modul-1.png',
    bage: 'Блок 1',
    title: 'Знакомство с методикой и первый опыт её применения в\u00A0учёбе',
    description:
      <>
        <div className={blocks.content}>
          <p className={blocks.text}>
            Ребёнок освоит техники и методы, которые позволят быстро запоминать в долгосрочную память и&nbsp;качественно воспроизводить школьный материал, а так же любую информацию по учёбе или работе.
          </p>
          <h4 className={blocks.skillsTitle}>
            Формируемые навыки:
          </h4>
          <div className={blocks.skillsWrap}>
            <div className={blocks.skillsList}>
              <div className={blocks.skillsListCol}>
                <div className={blocks.skillsItem}>
                  Фокусировать внимание от 30&nbsp;минут до 6&nbsp;часов;
                </div>
                <div className={blocks.skillsItem}>
                  Запоминать иностранные слова;
                </div>
                <div className={blocks.skillsItem}>
                  Запоминать майнд-карты;
                </div>
                <div className={blocks.skillsItem}>
                  Запоминать формулы;
                </div>
                <div className={blocks.skillsItem}>
                  Запоминать ударения, архаизмы и&nbsp;другую нелогичную информацию;
                </div>
                <div className={blocks.skillsItem}>
                  Развить воображение и&nbsp;визуальное (предметно-образное) мышление;
                </div>
                <div className={blocks.skillsItem}>
                  Выделять главное в тексте;
                </div>
                <div className={blocks.skillsItem}>
                  Запоминать даты истории и&nbsp;другую числовую информацию;
                </div>
                <div className={blocks.skillsItem}>
                  Запоминать стихи;
                </div>
              </div>
              <div className={blocks.skillsListCol}>
                <div className={blocks.skillsItem}>
                  Запоминать термины и определения;
                </div>
                <div className={blocks.skillsItem}>
                  Дольше сохранять сосредоточенность без&nbsp;усталости;
                </div>
                <div className={blocks.skillsItem}>
                  Усправление интеллектуальным состоянием, навык всегда «быть в ресурсе»;
                </div>
                <div className={blocks.skillsItem}>
                  Определять нужный способ запоминания;
                </div>
                <div className={blocks.skillsItem}>
                  Запоминать географические карты;
                </div>
                <div className={blocks.skillsItem}>
                  Запоминать тексты дословно;
                </div>
                <div className={blocks.skillsItem}>
                  Запоминать правила;
                </div>
                <div className={blocks.skillsItem}>
                  Увеличить интеллектуальный тонус;
                </div>
                <div className={blocks.skillsItem}>
                  Синхронизировать работу полушарий мозга.
                </div>
              </div>
            </div>
            <div className={blocks.cards}>
              <div className={blocks.cardsItem}>
                <div className={blocks.cardsHeader}>
                  <span className={blocks.cardsNum}>200</span><br/>
                  дат
                </div>
                <div className={blocks.cardsTxt}>
                  можно запомнить за&nbsp;2–3 часа
                </div>
              </div>
              <div className={blocks.cardsItem}>
                <div className={blocks.cardsHeader}>
                  <span className={blocks.cardsNum}>500+</span>
                  слов
                </div>
                <div className={blocks.cardsTxt}>
                  можно запомнить за&nbsp;один день
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={blocks.res}>
          <h4 className={blocks.resTitle}>
            Результат блока:
          </h4>
          <div className={`row ${blocks.resRow}`}>
            <div className={`col-12 col-xl-4 ${blocks.resCol}`}>
              <div className={blocks.resText}>
                Быстро и легко запоминать в&nbsp;долгосрочную память и&nbsp;воспроизводить информацию любого типа сложности.
              </div>
            </div>
            <div className={`col-12 col-xl-4 ${blocks.resCol}`}>
              <div className={blocks.resText}>
                Концентрация внимания от&nbsp;6&nbsp;минут до&nbsp;5&nbsp;часов позволит фокусироваться на&nbsp;целях и&nbsp;всегда быть бодрым и&nbsp;целеустремленным.
              </div>
            </div>
            <div className={`col-12 col-xl-4 ${blocks.resCol}`}>
              <div className={blocks.resText}>
                Ребёнок на своём опыте осознает, что его возможности в разы больше, чем он мог мечтать, и&nbsp;приобретёт опыт успешного управления своим развитием, что&nbsp;сделает его самостоятельным и более мотивированным.
              </div>
            </div>
          </div>
        </div>
      </>
  },
  {
    icon: 'https://fs.advance.ru/landing-pages/indi/kak_uchitya_doma/modul-2.png',
    bage: 'Блок 2',
    title: 'Технологии ускоренного обучения и работы с большими объемами информации',
    description:
      <>
        <div className={blocks.content}>
          <p className={blocks.text}>
            Ребенок научится понимать причинно-следственные связи, как составной элемент сложных информационных объектов, что
            является не только ключом к пониманию и логическому мышлению, но основой гениальности, ведь именно целостное понимание проблемы позволяет находить решения из самых разных областей.
          </p>
          <h4 className={blocks.skillsTitle}>
            Формируемые навыки:
          </h4>
          <div className={blocks.skillsWrap}>
            <div className={blocks.skillsList}>
              <div className={blocks.skillsListCol}>
                <div className={blocks.skillsItem}>
                  Формировать сложные представления;
                </div>
                <div className={blocks.skillsItem}>
                  Понимать причинно-следственные связи через работу с дефинициями;
                </div>
                <div className={blocks.skillsItem}>
                  Видеть логические связи;
                </div>
                <div className={blocks.skillsItem}>
                  Структурировать разрозненную информацию;
                </div>
                <div className={blocks.skillsItem}>
                  Самостоятельно работать со школьным материалом;
                </div>
                <div className={blocks.skillsItem}>
                  Находить определения и понимать термины;
                </div>
                <div className={blocks.skillsItem}>
                  Запоминать схемы, карты, планы;
                </div>
              </div>
              <div className={blocks.skillsListCol}>
                <div className={blocks.skillsItem}>
                  Встраивать новую информацию в общую картину;
                </div>
                <div className={blocks.skillsItem}>
                  Самостоятельно оценивать результат интеллектуального труда;
                </div>
                <div className={blocks.skillsItem}>
                  Классифицировать объекты и находить критерии для этого;
                </div>
                <div className={blocks.skillsItem}>
                  Понимать смысл алгоритмов и формул;
                </div>
                <div className={blocks.skillsItem}>
                  Переводить данные из слов в символы;
                </div>
                <div className={blocks.skillsItem}>
                  Увеличить скорость переключения внимания.
                </div>
              </div>
            </div>
            <div className={blocks.cards}>
              <div className={blocks.cardsItem}>
                <div className={blocks.cardsHeader}>
                  <span className={blocks.cardsNum}>2-4</span>
                </div>
                <div className={blocks.cardsTxt}>
                  Ребенок начинает учиться в 2–4 раза быстрее
                </div>
              </div>
              <div className={blocks.cardsItem}>
                <div className={blocks.cardsHeader}>
                  <span className={blocks.cardsNum}>4-5</span><br/>
                  дней
                </div>
                <div className={blocks.cardsTxt}>
                  достаточно для полного прохождения
                  любого учебника самостоятельно
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={blocks.res}>
          <div className={blocks.resTitle}>
            Результат блока:
          </div>
          <div className={`row ${blocks.resRow}`}>
            <div className={`col-12 col-xl-4 ${blocks.resCol}`}>
              <div className={blocks.resText}>
                Становится самостоятельным в&nbsp;учебе и сам делает домашние задания;
              </div>
            </div>
            <div className={`col-12 col-xl-4 ${blocks.resCol}`}>
              <div className={blocks.resText}>
                Учится быстрее, есть время на&nbsp;спорт, развитие и увлечения;
              </div>
            </div>
            <div className={`col-12 col-xl-4 ${blocks.resCol}`}>
              <div className={blocks.resText}>
                С удовольствием стремится к&nbsp;новым знаниям.
              </div>
            </div>
          </div>
        </div>
      </>
  },
  {
    icon: 'https://fs.advance.ru/landing-pages/indi/kak_uchitya_doma/modul-3.png',
    bage: 'Блок 3',
    title: 'Эффективное чтение',
    description:
      <>
        <div className={blocks.content}>
          <p className={blocks.text}>
            Ребенок освоит техники позволяющие быстрее читать и лучше
            запоминать и понимать прочитанный текст.
            Акцент делается именно на понимании материала.
          </p>
          <h4 className={blocks.skillsTitle}>
            Формируемые навыки:
          </h4>
          <div className={blocks.skillsWrap}>
            <div className={blocks.skillsList}>
              <div className={blocks.skillsListCol}>
                <div className={blocks.skillsItem}>
                  Осваиваем 7 методик скорочтения;
                </div>
                <div className={blocks.skillsItem}>
                  Увеличиваем скорость чтения от 2 до 4 раз;
                </div>
                <div className={blocks.skillsItem}>
                  Быстро находить нужное в сложном
                  информационном массиве;
                </div>
                <div className={blocks.skillsItem}>
                  Ставить цели при работе с текстом;
                </div>
                <div className={blocks.skillsItem}>
                  Ускоряем вокализацию – скорость проговаривания
                  текста (положительно сказывается на
                  дикции и развитии речевых навыков);
                </div>
              </div>
              <div className={blocks.skillsListCol}>
                <div className={blocks.skillsItem}>
                  Встраивать новую информацию в общую
                  картину на большой скорости;
                </div>
                <div className={blocks.skillsItem}>
                  Выбирать оптимальную методику
                  в зависимости от цели и от текста;
                </div>
                <div className={blocks.skillsItem}>
                  Функциональная грамотность;
                </div>
                <div className={blocks.skillsItem}>
                  Ещё большая интеллектуальная выносливость;
                </div>
              </div>
            </div>
            <div className={blocks.cards}>
              <div className={blocks.cardsItem}>
                <div className={blocks.cardsTxt}>
                  <b>Мы НЕ используем</b><br/>
                  методики подавления проговаривания
                </div>
              </div>
              <div className={blocks.cardsItem}>
                <div className={`${blocks.cardsTxt} ${blocks.cardsTxtSm}`}>
                  больше половины детей выходят на скорость чтения
                </div>
                <div className={blocks.cardsHeader}>
                  <b>более 500 слов</b>
                </div>
                <div className={`${blocks.cardsTxt} ${blocks.cardsTxtSm}`}>
                  в минуту с полным пониманием прочитанного материала
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={blocks.res}>
          <div className={blocks.resTitle}>
            Результат блока:
          </div>
          <div className={`row ${blocks.resRow}`}>
            <div className={`col-12 col-xl-3 ${blocks.resCol}`}>
              <div className={blocks.resText}>
                Ребенок начинает Читать с большой буквы;
              </div>
            </div>
            <div className={`col-12 col-xl-3 ${blocks.resCol}`}>
              <div className={blocks.resText}>
                Выход на скорость «книга за вечер» делает груду книг
                из испорченного домашкой лета всего лишь недельной задачей,
                что резко снижает масштаб и сложность всех остальных жизненных задач;
              </div>
            </div>
            <div className={`col-12 col-xl-3 ${blocks.resCol}`}>
              <div className={blocks.resText}>
                Любовь к чтению становится надежной опорой
                для любви к учебе и развитию на протяжении всей жизни;
              </div>
            </div>
            <div className={`col-12 col-xl-3 ${blocks.resCol}`}>
              <div className={blocks.resText}>
                Люди, читающие книги, всегда будут
                управлять теми, кто смотрит телевизор.
              </div>
            </div>
          </div>
        </div>
      </>
  },
  {
    icon: 'https://fs.advance.ru/landing-pages/indi/kak_uchitya_doma/modul-4.png',
    bage: 'Блок 4',
    title: 'Базовая информация по основным школьным предметам',
    description:
      <>
        <div className={blocks.content}>
          <p className={blocks.text}>
            Все освоенные на курсе навыки ребенок отрабатывает на
            базовом материале школьных предметов, что позволяет
            одновременно повторить и загрузить в долгосрочную память
            ранее пройденный материал и создать фундамент для понимания
            еще не пройденного, за счет предварительной загрузки формул и
            определений в память до разбора соответствующего предмета в школе.

          </p>
          <h4 className={blocks.skillsTitle}>
            Формируемые навыки:
          </h4>
          <div className={blocks.skillsWrap}>
            <div className={blocks.skillsList}>
              <div className={blocks.skillsListCol}>
                <div className={blocks.skillsItemClasses}>
                  <img src="https://fs.advance.ru/landing-pages/indi/kak_uchitya_doma/icon-1.svg" alt=""/>
                  <div>
                    <h5>
                      Английский язык
                    </h5>
                    <p>
                      Первые 150 слов. Неправильные глаголы. 16 времен.
                      Грамматика. Лексика для ОГЭ и ЕГЭ.
                    </p>
                  </div>
                </div>
                <div className={blocks.skillsItemClasses}>
                  <img src="https://fs.advance.ru/landing-pages/indi/kak_uchitya_doma/icon-2.svg" alt=""/>
                  <div>
                    <h5>
                      Математика
                    </h5>
                    <p>
                      9 величин, 86 формул и 10 признаков делимости.
                    </p>
                  </div>
                </div>
                <div className={blocks.skillsItemClasses}>
                  <img src="https://fs.advance.ru/landing-pages/indi/kak_uchitya_doma/icon-3.svg" alt=""/>
                  <div>
                    <h5>
                       Геометрия
                    </h5>
                    <p>
                      76 определений, 90 теорем и 13 аксиом.
                    </p>
                  </div>
                </div>
                <div className={blocks.skillsItemClasses}>
                  <img src="https://fs.advance.ru/landing-pages/indi/kak_uchitya_doma/icon-4.svg" alt=""/>
                  <div>
                    <h5>
                       География
                    </h5>
                    <p>
                      Страны и столицы. Субъекты, крупные города и округа
                      РФ и Европы. Материки. Созвездия. Типы гор.
                      Глубины и площади морей и озер.
                    </p>
                  </div>
                </div>
                <div className={blocks.skillsItemClasses}>
                  <img src="https://fs.advance.ru/landing-pages/indi/kak_uchitya_doma/icon-5.svg" alt=""/>
                  <div>
                    <h5>
                       ОБЖ
                    </h5>
                    <p>
                      Классификация техногенных чрезвычайных ситуаций.
                    </p>
                  </div>
                </div>
              </div>
              <div className={blocks.skillsListCol}>
                <div className={blocks.skillsItemClasses}>
                  <img src="https://fs.advance.ru/landing-pages/indi/kak_uchitya_doma/icon-6.svg" alt=""/>
                  <div>
                    <h5>
                       Биология
                    </h5>
                    <p>
                      Анатомия, зоология, ботаника. Способ выучивания схем.
                    </p>
                  </div>
                </div>
                <div className={blocks.skillsItemClasses}>
                  <img src="https://fs.advance.ru/landing-pages/indi/kak_uchitya_doma/icon-7.svg" alt=""/>
                  <div>
                    <h5>
                       Русский язык
                    </h5>
                    <p>
                      206 ударений для ЕГЭ, архаизмы. Остальное ребенок освоит сам.
                    </p>
                  </div>
                </div>
                <div className={blocks.skillsItemClasses}>
                  <img src="https://fs.advance.ru/landing-pages/indi/kak_uchitya_doma/icon-8.svg" alt=""/>
                  <div>
                    <h5>
                       Физика
                    </h5>
                    <p>
                      61 формула и 27 величин для этих формул.
                    </p>
                  </div>
                </div>
                <div className={blocks.skillsItemClasses}>
                  <img src="https://fs.advance.ru/landing-pages/indi/kak_uchitya_doma/icon-9.svg" alt=""/>
                  <div>
                    <h5>
                       Химия
                    </h5>
                    <p>
                      Таблица Менделеева. Формулы.
                      Аминокислоты и их обозначение. Номенклатура алканов..
                    </p>
                  </div>
                </div>
                <div className={blocks.skillsItemClasses}>
                  <img src="https://fs.advance.ru/landing-pages/indi/kak_uchitya_doma/icon-10.svg" alt=""/>
                  <div>
                    <h5>
                       Литература
                    </h5>
                    <p>
                      Даты жизни писателей.
                    </p>
                  </div>
                </div>
                <div className={blocks.skillsItemClasses}>
                  <img src="https://fs.advance.ru/landing-pages/indi/kak_uchitya_doma/icon-11.svg" alt=""/>
                  <div>
                    <h5>
                       История
                    </h5>
                    <p>
                      Романовы и Рюрики. 340 дат истории России.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className={blocks.cards}>
              <div className={blocks.cardsItem}>
                <div className={blocks.cardsTxt}>
                  Дети начинают понимать учителей на уроке
                  в реальном времени, а не через год
                  при прохождении темы с репетитором
                </div>
              </div>
              <div className={blocks.cardsItem}>
                <div className={blocks.cardsTxt}>
                  Школьные предметы щелкаются как орешки
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={blocks.res}>
          <div className={blocks.resTitle}>
            Результат блока:
          </div>
          <div className={`row ${blocks.resRow}`}>
            <div className={`col-12 col-xl-6 ${blocks.resCol}`}>
              <div className={blocks.resText}>
                Прохождение базы школьных предметов позволяет быстро
                выучить и сдать вперед все непрофильные предметы,
                чтобы высвободить время для по настоящему важных и интересных задач;
              </div>
            </div>
            <div className={`col-12 col-xl-6 ${blocks.resCol}`}>
              <div className={blocks.resText}>
                Учеба перестает быть трудностью, и аккуратно занимает
                положенное место в расписании, не разрастаясь в
                свободное время ребенка и родителей.
              </div>
            </div>
          </div>
        </div>
      </>
  },
  {
    icon: 'https://fs.advance.ru/landing-pages/indi/kak_uchitya_doma/modul-5.png',
    bage: 'Блок 5',
    title: 'Личная эффективность (soft skills)',
    description:
      <>
        <div className={blocks.content}>
          <p className={blocks.text}>
            Как езда на автомобиле сильно отличается от езды на велосипеде,
            так и новая скорость в работе с информацией требует других
            навыков личной эффективности. Мы сделали все, чтобы ребенок
            осознал свои новые возможности и научился использовать их на 100%.
          </p>
          <h4 className={blocks.skillsTitle}>
            Формируемые навыки:
          </h4>
          <div className={blocks.skillsWrap}>
            <div className={blocks.skillsList}>
              <div className={blocks.skillsListCol}>
                <div className={blocks.skillsItem}>
                  Планирование с опорой на собственный опыт;
                </div>
                <div className={blocks.skillsItem}>
                  Разбивать большие задачи на посильные подзадачи;
                </div>
                <div className={blocks.skillsItem}>
                  Осознавать свои навыки, усиливать имеющиеся и осваивать новые;
                </div>
                <div className={blocks.skillsItem}>
                  Целеполагание по технологии SMART;
                </div>
                <div className={blocks.skillsItem}>
                  Управление временными ресурсами (тайм-менеджмент);
                </div>
              </div>
              <div className={blocks.skillsListCol}>
                <div className={blocks.skillsItem}>
                  Самостоятельно ставить и выполнять учебный план;
                </div>
                <div className={blocks.skillsItem}>
                  Алгоритмы работы с информацией для повышения
                  скорости и качества ее обработки;
                </div>
                <div className={blocks.skillsItem}>
                  Навык саморефлексии, позволяющий самостоятельно
                  оценить результат учебы или интеллектуального
                  труда по критериям знаю/не знаю, качественно/не
                  качественно, в срок/не в срок и т.д.
                </div>
              </div>
            </div>
            <div className={blocks.cards}>
              <div className={blocks.cardsItem}>
                <div className={blocks.cardsHeader}>
                  <span className={blocks.cardsNumLg}>15%</span>
                </div>
                <div className={`${blocks.cardsTxt} ${blocks.cardsTxtSm}`}>
                  наших выпускников переходят на экстернат
                  или самостоятельно осваивают новые профессии
                </div>
              </div>
              <div className={blocks.cardsItem}>
                <div className={`${blocks.cardsTxt} ${blocks.cardsTxtSm}`}>
                  Понимание механизма управления жизнью через
                  управление портфелем своих компетенций
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={blocks.res}>
          <div className={blocks.resTitle}>
            Результат блока:
          </div>
          <div className={`row ${blocks.resRow}`}>
            <div className={`col-12 col-xl-4 ${blocks.resCol}`}>
              <div className={blocks.resText}>
                Становится самостоятельным в учебе
                и сам делает домашние задания;
              </div>
            </div>
            <div className={`col-12 col-xl-4 ${blocks.resCol}`}>
              <div className={blocks.resText}>
                Учится быстрее, есть время на спорт,
                развитие и увлечения;
              </div>
            </div>
            <div className={`col-12 col-xl-4 ${blocks.resCol}`}>
              <div className={blocks.resText}>
                С удовольствием стремится к новым знаниям.
              </div>
            </div>
          </div>
        </div>
      </>
  },
];
